import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { IWizItemRenderer, WizEventManager } from '@wizeoo/akm-component-lib';
import { WidgetConfigurationItemObj, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { BaselineEngine, FeiKeyDef, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';


import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { ViewData } from '../../../../model/view.data';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { FeiVO } from '../../../../vo/workingdata/fei.vo';
import { TileWidget } from '../tile.widget';

/**
 * Vignette de présentation d'un rôle pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'tile-renderer',
  templateUrl: './tile.renderer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileRenderer implements IWizItemRenderer<null, WidgetLine> {

  public widgets: GridsterWidgetItem[] = []; // item de travail
  public wco: WidgetConfigurationObj = null; // la conf du widget pour rendu des tuiles
  public masterTileWidget: TileWidget = null; // le widget parent pour écouteur de changement de rendu des tuiles
  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
  }

  private _owner: any;
  public get owner(): any {
    return this._owner;
  }
  public set owner(owner: any) {
    this._owner = owner;
    this.masterTileWidget = this.owner.wizContext[0];
    WizEventManager.addListener(this, this.masterTileWidget, ALK_EVENT_TYPE.TILE_RENDERER_UPDATED, this.tileRendererUpdate);
    this.wco = this.owner.wizContext[1];
    // console.log('owner', this.owner);
    this.build();
    this.cdref.markForCheck();
  }

  // Le VO manipulé
  private _data: WidgetLine;
  public get data(): WidgetLine {
    return this._data;
  }
  public set data(data: WidgetLine) {
    this._data = data;
  }

  public get fei(): FeiVO {
    return this.masterTileWidget?.fei;
  }


  private tileRendererUpdate(e: AlkEvent): void {
    this.wco = e.data;
    this.build();
    // console.log('tileRendererUpdate', this.owner);
    this.cdref.markForCheck();
  }

  /**
   * construction des rendus
   */
  private build(): void {
    if (!!this.data && !!this.wco) {
      
      const widItems: GridsterWidgetItem[] = []; // les champs à construire
      const ffs: WidgetConfigurationItemObj[] = this.wco.ff; // la conf gridster : les champs à afficher dans le form

      // en passant par le composant bl-gridster, on va instancier des ffRenderer
      ffs?.forEach((wcio: WidgetConfigurationItemObj) => {
        const fkd: FeiKeyDef = BaselineEngine.getKey(this.fei, wcio.cod);
        const splittedCode: string = wcio.cod.split(WizConstants.CONTEXT_SEPARATOR)[0]; // pour accepter les champs fakes (champs libres)
        if (!!fkd 
          || splittedCode === ViewData.FORM_ACTION
          || splittedCode === ViewData.FORM_HTML
          || splittedCode === ViewData.FORM_IMAGE) { // le champ doit exister, sinon on ajoute pas
          const ffo: FormFieldObj = new FormFieldObj(this.masterTileWidget, this.fei, wcio);
          const gwi: GridsterWidgetItem = new GridsterWidgetItem(wcio, ffo);
          widItems.push(gwi);
        }
      });  
      this.widgets = widItems;
    }
  }

}
